import React, { useCallback, useMemo, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, getActions, addActionOnRow } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { CouponForm } from '../coupon-form/CouponForm'
import { useSelector } from 'react-redux'

export const CouponView = () => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/coupon'
  })

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'tipo-eventos' })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_coupon

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <CouponForm rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/coupon/delete',
            data: {
              p_id_coupon: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        { name: 'name_event', text: 'Evento', align: 'center' },
        { name: 'name_coupon', text: 'Nombre', align: 'center' },
        { name: 'key_coupon', text: 'Clave', align: 'center' },
        { name: 'amount_coupon', text: 'Monto', align: 'center' },
        { name: 'type_coupon', text: 'Tipo', align: 'center', render: r => {
          return r.type_coupon === 'PERCENTAGE' ? 'Porcentaje' : 'Monto'
        } },
        { name: 'enabled_coupon', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_coupon }) },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          {rowItem({
            type: 'create'
          })}
          {dtRows}
        </Card.Body>
      </Card>
    </div>
  </div>
}